import { useState, useEffect,useRef } from "react";
import React from 'react';
import {
  Button,
  Card,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Input,
  CardHeader,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import { toast } from 'react-toastify';
import { useHistory,useParams } from "react-router-dom";
import Select from 'react-select';
import { taskmanageService } from '../../services/taskmanageService';
const axios = require("axios");

const ChecklistFormData = (props) => {
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const params = useParams();
  const [disablestate, setdisablestate] = useState(false);
  const [currentphase, setcurrentPhase] = useState('');

  const [checklistData, setCheckListData] = useState([]);
  const [checklistMasterData, setCheckListMasterData] = useState([]);
  const formRef = useRef();
  const [reviewMasterChecklist,setReviewChecklistMasterModalOpen] = useState(false);  
  const [reviewChecklist,setReviewChecklistModalOpen] = useState(false);
  const [checkstate, setchecklistState] = useState({task_id:null,phase_id:null,data:null});

useEffect(() => {
  console.log(params)
  addreviewchecklist(params.task_id,params.frequency,params.main_id,params.type)
}, []);

useEffect(() => { // when load then click on first phase button
  if (checklistMasterData.length > 0) {
    addreviewchecklist(checklistMasterData[0].task_id,checklistMasterData[0].frequency, checklistMasterData[0].phase_id, "phases");
  }
}, [checklistMasterData]);

function add_checklist_data(e) {

  e.preventDefault();
  var type = '';
  if(user_info.phase_id != null && user_info.phase_id != ''){
     type ='phases';
  }else{
     type ='tasks';
  }

  console.log('sd',checkstate)
  taskmanageService.addChecklistData(checkstate,type,sub_cat).then((response) => {
    console.log(response);

    if (response.status == 200) {
      toast.success(response.data.message);
      setReviewChecklistModalOpen(!reviewChecklist);
      setReviewChecklistMasterModalOpen(false);
    }else{
      toast.error(response.data.message);
    }
    setdisablestate(false)
  });
}
function addreviewchecklist(id,frequency,main_id='',type='tasks'){
  setCheckListData([]);
  getchecklistData(id,frequency,main_id,type)
  
}
const[sub_cat,setSubCat]=useState('');
function getchecklistData(task_id,frequency,id,type){
  setcurrentPhase(id)
    taskmanageService.getchecklistData(task_id,frequency,type,id).then((response) => {
      if(type == 'phases'){
        console.log(response.data.data)
        setCheckListData(response.data.data);
        if (response.data.data && typeof response.data.data === 'object') {
          const firstKey = Object.keys(response.data.data)[0]; // Get the first key
          setSubCat(firstKey);
          
        }
      
        setchecklistState({ ...checkstate,data: response.data.data,task_id: response.data.task_id,phase_id: response.data.phase_id}); 
       
      }else{
        setCheckListMasterData(response.data.data)
        getchecklistSubCat();
      }
      
    });
    if(type == 'phases'){
      setReviewChecklistModalOpen(!reviewChecklist);
    }else{
      setReviewChecklistMasterModalOpen(!reviewMasterChecklist);
    }
   
};
function getchecklistSubCat(){
  taskmanageService.getchecklistSubCatData(currentphase).then((response) => {
  })

}
function inputhandlerchecklist(e, field, index,form_id,task_id,phase_id,master_id,sub_cat) {
console.log(checklistData)
  let temp_m = [...checklistData[sub_cat]];
  let temp_ele = { ...temp_m[index] };

  let temp_st = { ...checkstate.data[sub_cat] };
  var value = '';
  if (field === "status") {
    const { checked } = e.target;
    if (!temp_st[index]) {
      temp_st[index] = {}; // Ensure the object exists
    }
    temp_st[index][field] = checked ? 1 : 0;
    value = checked ? 1 : 0;
  }else if(field=='file'){
    const fileType = e.target.files[0].type;
    if (
      fileType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
      fileType !== 'application/vnd.ms-excel' && // For .xls
      fileType !== 'image/jpeg' // For .jpg or .jpeg
    ) {
      // If file is invalid, show an alert and clear the input
      alert('Please upload only Excel or JPG/JPEG files.');
      e.target.value = ''; // Clear the file input
      return; // Stop further processing
    }
    temp_st[index][field] = e.target.files[0];
  } else if(field == "phase_rejection" || field === "qa_rejection"){
      if(field == 'phase_rejection'){
        if(temp_ele.phase_feedback == "" || temp_ele.phase_feedback == null){
          toast.error("Please fill feedback to auditpod.");
          return;
        }
      }
      if(field == 'qa_rejection'){
        if(temp_ele.qa_feedback == ""  || temp_ele.qa_feedback == null){
          toast.error("Please fill feedback to QA.");
          return;
        }
      }
    if (!temp_st[index]) {
      temp_st[index] = {}; // Ensure the object exists
    }
    temp_st[index][field] = e;
    value = e;
  }else {
    if (!temp_st[index]) {
      temp_st[index] = {}; // Ensure the object exists
    }
    temp_st[index][field] = e.target.value;
    value = e.target.value;
  }

  temp_ele[field] = value;
  temp_ele.editing = false;
  temp_m[index] = temp_ele;

  //setCheckListData(temp_m);

  //setchecklistState({ ...checkstate, data: temp_st });
  setCheckListData(prevState => ({
    ...prevState,
    [sub_cat]: temp_m // Update specific sub_cat with temp_m
}));
  setchecklistState(prevState => ({
    ...prevState,
    data: {
      ...prevState.data, // Preserve existing data
      [sub_cat]: temp_st // Update specific sub_cat with temp_st
    }
  }));

  // taskmanageService.editChecklistForm(value, field, form_id, task_id,phase_id,master_id).then((response) => {

  // })
}
const handleeditRow = (index,sub_cat) => {
    let temp_state = [...checklistData[sub_cat]];
    let temp_element = { ...temp_state[index] };
    temp_element.editing = true;
    temp_state[index] = temp_element;
    setCheckListData(prevState => ({
      ...prevState,
      [sub_cat]: temp_state // Update specific sub_cat with temp_m
  }));
    //setCheckListData(temp_state);
};

const checklistdownloadfile = (path,name,extension) => {
  taskmanageService.checklist_download_file(path,name,extension).then((response) => {
  
  });
}
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
      {(user_info.phase_id == null)? 
      <>
      <Row >
      <h3>Checklist Phases </h3>
      </Row>
      <Row >
      {checklistMasterData.length > 0 && checklistMasterData  ? (
                        checklistMasterData.map((item, i) => (
               
                 <button type="button"  className=" btn btn-secondary text-center" 
                          style={{ backgroundColor: currentphase === item.phase_id ? '#11cdef' : 'initial' }}
                          onClick={(e) => addreviewchecklist(item.task_id,item.phase_id,'phases')}>
                 {item.desc}
               </button> 
                 ))
                 ) : (
                  <div>
                  <span >No Data Found</span>
                  </div>
                )}
              
  
          </Row>
          </>
          :null}

          <Row className="mt-2">
      
    </Row>
        <Row className="mt-5">
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
            {checklistData ?
              <CardHeader>
              {checklistData && Object.keys(checklistData).length > 0 && sub_cat !=='' ? (
        Object.keys(checklistData).map((subCat, index) => (
          <button
            key={index} // Ensure each button has a unique key
            type="button"
            className="btn btn-secondary text-center"
            style={{ backgroundColor: subCat === sub_cat ? '#11cdef' : 'initial' }}
            onClick={() => setSubCat(subCat)} // Update state on click
          >
            {subCat || sub_cat}
          </button>
        ))
      ) : ''}
              </CardHeader> : ''}
            {checklistData[sub_cat] ?
            <>
            <div>
              
            </div>
            <h2 className="mt-3">Checklist Form</h2>
            <Form role="form" ref={formRef} id="add_checklist_form" > 
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th >Sr. No.</th>
                    <th className="whitespace">Category</th>
                    <th className="whitespace">Checklist</th>
                   
                    <th  className="whitespace">Status</th>
                    <th>Remarks</th>
                    <th>Upload<p style={{color:'red',fontSize:'12px'}}>(Accepting only Excel and Jpg file)</p></th>
                     
                  </tr>
                </thead>
                <tbody>
                {  checklistData[sub_cat] && checklistData[sub_cat].length > 0  ? (
                        checklistData[sub_cat].map((list, i) => (
                <tr key={i} className={((i % 2 == 0)? 'blue-row':(i % 3 == 0)?'purple-row':'orange-row') } style={{background: (list.phase_rejection == 1 || list.qa_rejection == 1)?`#fdf42a`: null}}>
                  <td>{i+1}</td>
                  <td className="whitespace">{list.category}</td>
                  <td className="whitespace">{list.checklist}</td>
                  
                 
                  <td>
                  <input
                    type="checkbox"
                    id={`requiredQACheckbox${i}`}
                    name="status"
                    checked={checkstate.data && checkstate.data[sub_cat] && checkstate.data[sub_cat][i] ? checkstate.data[sub_cat][i].status === 1 : false}
                    value={checkstate.data && checkstate.data[sub_cat] ? checkstate.data[sub_cat].status : ''}
                    onChange={(e) => inputhandlerchecklist(e, "status", i,list.id,checkstate.task_id,list.phase_id,list.master_id,sub_cat)}
                  />
                  </td>
                 
                  {/* <td>{list.remarks} </td> */}
               
              
                  <td>
                 
                    <Input type="textarea" placeholder="Remarks" name ="remarks"   value={list.remarks ? list.remarks : ''}
                    onChange={(e) =>
                      inputhandlerchecklist(
                        e,
                        "remarks",
                        i,list.id,checkstate.task_id,list.phase_id,list.master_id,sub_cat
                      )} />
                 
                  </td>
                  <td><input type="file"    name="file" id="import_file" className="text-right" accept=".xlsx, .xls, .jpg, .jpeg"  onChange={(e) =>
                      inputhandlerchecklist(
                        e,
                        "file",
                        i,list.id,checkstate.task_id,list.phase_id,list.master_id,sub_cat
                      )}  />
                      
                  {list.attachment ? (
                  <a style={{cursor:"pointer",color:"#2FC3B9"}} onClick={() => checklistdownloadfile(list.attachment)}>Download</a>
                  ):''}
                  </td>
                
                </tr>
                  ))
                  ) : (
                   <tr>
                   <td>No Data Found</td>
                   </tr>
                 )}
                
            
                </tbody>
              </Table>
              <br></br>
               {/* {(datatype == 0) ? */}
               <Button color="primary" type="button" onClick={add_checklist_data} disabled={disablestate}>
            {disablestate ? 'Sending...' : 'Send'} 
              </Button> 
              {(user_info.role_id == 3) ?
              <span style={{color:"red",fontSize:"12px"}}> Data is auto save so after click on send button then data will not be editable and then only job status can be changed to complete.</span>
              : null } 
              </Form>
              </>
          : <p>No data Found!</p> }
            </Card>
          </div>
        </Row>
        <Row>
         
        </Row>

      </Container>
    </>
  );
};


export default ChecklistFormData;
